var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnitedKingdom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 40C31.046 40 40.0003 31.0457 40.0003 20C40.0003 8.9543 31.046 0 20.0003 0C8.95458 0 0.000274658 8.9543 0.000274658 20C0.000274658 31.0457 8.95458 40 20.0003 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.13439 7.82373C2.56337 9.86771 1.37876 12.2236 0.688995 14.7829H11.0935L4.13439 7.82373Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3111 14.7829C38.6213 12.2237 37.4366 9.86784 35.8657 7.82385L28.9067 14.7829H39.3111Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.688995 25.2177C1.37884 27.7769 2.56345 30.1327 4.13439 32.1766L11.0933 25.2177H0.688995Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1764 4.13456C30.1324 2.56354 27.7766 1.37893 25.2173 0.689087V11.0935L32.1764 4.13456Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.82364 35.8656C9.86762 37.4367 12.2235 38.6213 14.7827 39.3111V28.9067L7.82364 35.8656Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7826 0.689087C12.2234 1.37893 9.86755 2.56354 7.82364 4.13448L14.7826 11.0935V0.689087Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2173 39.3111C27.7765 38.6213 30.1324 37.4367 32.1763 35.8657L25.2173 28.9067V39.3111Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9067 25.2177L35.8657 32.1767C37.4366 30.1328 38.6213 27.7769 39.3111 25.2177H28.9067Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.831 17.3913H22.6091H22.609V0.169297C21.755 0.058125 20.8844 0 20.0003 0C19.116 0 18.2455 0.058125 17.3916 0.169297V17.3912V17.3913H0.169572C0.0583997 18.2452 0.000274658 19.1159 0.000274658 20C0.000274658 20.8843 0.0583997 21.7548 0.169572 22.6087H17.3914H17.3915V39.8307C18.2455 39.9419 19.116 40 20.0003 40C20.8844 40 21.755 39.942 22.6089 39.8307V22.6088V22.6087H39.831C39.9422 21.7548 40.0003 20.8843 40.0003 20C40.0003 19.1159 39.9422 18.2452 39.831 17.3913V17.3913Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2174 25.2176L34.1421 34.1423C34.5526 33.732 34.9441 33.303 35.3177 32.8583L27.6769 25.2175H25.2174V25.2176Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7827 25.2175H14.7825L5.85791 34.1421C6.26822 34.5526 6.69721 34.9442 7.14189 35.3178L14.7827 27.6768V25.2175Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7827 14.7827V14.7826L5.85797 5.85779C5.4475 6.2681 5.05594 6.69708 4.68234 7.14177L12.3232 14.7826H14.7827V14.7827Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2174 14.7828L34.1422 5.85792C33.7319 5.44745 33.3029 5.05589 32.8582 4.68237L25.2174 12.3232V14.7828Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedKingdom);
export default __webpack_public_path__ + "static/media/united_kingdom.b576e96cccf7344ec8783a51630b7bcb.svg";
export { ForwardRef as ReactComponent };